import generatePassword from 'omgopass';

export const generateStr = () => {
  return generatePassword({
    minSyllableLength: 8,
    hasNumbers: true,
    titlecased: true,
    separators: ''
  });
};
